<template src="@/templates/report/report.html"></template>

<script>
import jobActivity from "@/components/report/job/Activity";

export default {
  name: "Report",
  components: {
    jobActivity,
  },
  data() {
    return {
      selectedComponent: jobActivity,
    };
  },
};
</script>
